import React, { Component } from "react";
import { compose, graphql } from "react-apollo";

import HeaderLinks from "./HeaderLinks.jsx";
import { Navbar } from "react-bootstrap";
import Queries from "../../queries/queries2";
import dashRoutes from "../../routes/dash.jsx";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

// links that appear in navbar - they are separated from this component (navbar) so that we can redner them on responsive in sidebar as well


// we import here the routes for dashboard pages (links that appear in sidebar) to set navbar's name


class Header extends Component {
  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
  }
  makeBrand() {
    var name;
    dashRoutes(this.props).map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = this.props.intl.formatMessage({ id: prop.name });
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = this.props.intl.formatMessage({ id: prop.name });
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = this.props.intl.formatMessage({ id: prop.name });
          }
        }
      }
      return null;
    });
    return name;
  }
  mobileSidebarToggle(e) {
    document.documentElement.classList.toggle("nav-open");
  }
  render() {
    return (
      <Navbar fluid>
        <Navbar.Header>
          <Navbar.Brand>
            {/* Here we create navbar brand, based on route name */}
            {/* We were asked to replace Page name by Company Name
                            <a href="#pablo">{this.makeBrand()}</a> */}
            {this.props.companyName.company &&
              this.props.companyName.company.name && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a href="">{this.props.companyName.company.name}</a>
              )}
          </Navbar.Brand>
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>

        {/* Here we import the links that appear in navbar */}
        {window.innerWidth > 992 ? (
          <Navbar.Collapse>
            <HeaderLinks {...this.props} />
          </Navbar.Collapse>
        ) : null}
      </Navbar>
    );
  }
}

//export default Header;
export default compose(
  graphql(Queries.getCompanyName, { name: "companyName" })
)(injectIntl(withRouter(Header)));
